<div *ngIf="!AccessAllowed && CompletedLoading">
    <h3 style="border: 2px solid;border-radius: 6px;position: absolute;top: 50%;left: 50%;transform: translate(-50%, -50%);padding: 10px;">You don't have access to this function</h3>
</div>

<!-- ── Mobile view ─────────────────────────────────────────── -->
<div *ngIf="useMobileView && ListBookings && AccessAllowed">

  <!-- Toolbar -->
  <div class="mob-toolbar">
    <!-- Name search row -->
    <div class="mob-toolbar-inner" style="margin-bottom:8px;">
      <div class="mob-name-search-wrap">
        <span class="p-input-icon-left mob-name-search-input-wrap">
          <i class="pi pi-search"></i>
          <input class="mob-name-search-input" pInputText type="text"
                 placeholder="Search bookings"
                 [(ngModel)]="searchCriteria"
                 (keyup.enter)="getSearchResults()"/>
        </span>
        <button class="mob-name-search-btn" type="button" (click)="getSearchResults()">
          <i class="pi pi-search"></i>
        </button>
      </div>
    </div>
    <div class="mob-toolbar-inner">
      <button pButton type="button"
              class="p-button-sm p-button-warning mob-criteria-btn"
              (click)="showCriteria()">
        <span class="pi pi-sliders-h" style="margin-right:6px;"></span>
        {{criteria ? 'Hide Criteria' : 'Show Criteria'}}
      </button>
      <p-toggleButton [(ngModel)]="isDisabled"
                      offIcon="pi pi-eye-slash" onIcon="pi pi-eye"
                      [style]="{'height':'40px','color':'white','background-color':'#EF4444','border-color':'#EF4444'}"
                      (click)="toggleDisabled()">
      </p-toggleButton>
    </div>
  </div>

  <!-- Collapsible criteria panel -->
  <div *ngIf="criteria" class="mob-criteria-panel">
    <div class="mob-criteria-row">
      <label class="mob-criteria-label">From</label>
      <p-calendar [selectOtherMonths]="true" [(ngModel)]="BookingDate"
                  firstDayOfWeek="1" dateFormat="dd/mm/yy" [utc]="false"
                  [showIcon]="true" [style]="{'width':'100%'}">
      </p-calendar>
    </div>
    <div class="mob-criteria-row">
      <label class="mob-criteria-label">To</label>
      <p-calendar [selectOtherMonths]="true" [(ngModel)]="BookingDateEnd"
                  firstDayOfWeek="1" dateFormat="dd/mm/yy" [utc]="false"
                  [showIcon]="true" [style]="{'width':'100%'}">
      </p-calendar>
    </div>
    <div class="mob-criteria-row">
      <label class="mob-criteria-label">Tags</label>
      <p-multiSelect [options]="tags" optionLabel="name" [(ngModel)]="chosentags"
                     display="chip" [style]="{'width':'100%'}">
        <ng-template let-value pTemplate="selectedItems">
          <span *ngFor="let tag of chosentags">
            <p-chip label="{{tag.name}}" styleClass="mr-2"
                    [style]="{'background': tag.colour, 'color': 'white', 'border-radius': '5px'}">
            </p-chip>
          </span>
          <div *ngIf="!chosentags || chosentags.length === 0" class="country-placeholder">Select Tag(s)</div>
        </ng-template>
      </p-multiSelect>
    </div>
    <button pButton type="button" class="p-button-warning mob-search-btn"
            (click)="showBookings(); showCriteria()">
      <span class="pi pi-search" style="margin-right:6px;"></span>Search
    </button>
  </div>

  <!-- Title bar -->
  <div class="mob-title-bar">{{BookingsTitle}}</div>

  <!-- Table -->
  <div class="surface-card shadow-2">
    <p-table [value]="ListBookings"
             sortField="startTime"
             [paginator]="true" [rows]="10"
             [showCurrentPageReport]="true"
             currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
             [rowsPerPageOptions]="[10,25,50]"
             [globalFilterFields]="['name','bookingId','bookingIdHR','packageName']"
             responsiveLayout="scroll"
             styleClass="mob-booking-table">

      <ng-template pTemplate="header">
        <tr>
          <th class="mob-stripe-th"></th>
          <th pSortableColumn="startTime">Booking</th>
          <th pSortableColumn="total" style="text-align:right">Amount</th>
          <th style="width:48px"></th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-data>
        <tr [ngStyle]="{'background-color': data.disabled ? '#fff1f2' : ((data.allergy != null && data.allergy != '') ? '#FFFFB2' : '#ffffff')}"
            class="mob-data-row"
            *ngIf="!data.inProgress && !inProgress"
            (click)="editdatanew(data.bookingId)">

          <td class="mob-status-stripe"
              [ngStyle]="{'background-color': data.disabled ? '#ef4444' : ((data.allergy != null && data.allergy != '') ? '#d97706' : '#94a3b8')}">
          </td>

          <td class="mob-main-cell">
            <div class="mob-main-line1">
              <span class="mob-time">{{data.startTime | date:'HH:mm' : 'UTC'}}</span>
              <span class="mob-name">{{data.name}}</span>
              <span class="mob-inline-icons">
                <i *ngIf="data.publicBooking"   class="pi pi-user               mob-iico"></i>
                <i *ngIf="data.awaitingpayment" class="pi pi-dollar             mob-iico mob-iico--red" pTooltip="Payment link sent"></i>
                <i *ngIf="data.notes"           class="pi pi-exclamation-circle  mob-iico mob-iico--red" [pTooltip]="data.notes"></i>
                <i *ngIf="data.disabled"        class="pi pi-ban                mob-iico mob-iico--red"></i>
                <i *ngIf="data.allergy"         class="pi pi-star               mob-iico mob-iico--amber"></i>
              </span>
            </div>
            <div class="mob-main-line2">
              <span class="mob-bookingid">{{data.bookingIdHR}}</span>
              <span class="mob-pkg" *ngIf="data.packageName">&nbsp;&middot;&nbsp;{{data.packageName}}</span>
              <span class="mob-guests" *ngIf="data.guests">&nbsp;&middot;&nbsp;{{data.guests}} guest{{data.guests != 1 ? 's' : ''}}</span>
            </div>
          </td>

          <td class="mob-money-cell">
            <div class="mob-total">{{data.total | currency: (data.currency || CurrencySymbol)}}</div>
            <div [class.mob-os--overdue]="data.outstanding > 0" [class.mob-os--paid]="data.outstanding <= 0">
              {{data.outstanding | currency: (data.currency || CurrencySymbol)}}
            </div>
          </td>

          <td class="mob-action-cell" (click)="$event.stopPropagation()">
            <button pButton type="button"
                    class="p-button-text p-button-plain mob-action-btn"
                    icon="pi pi-ellipsis-v"
                    (click)="selectedAction = data; blRowActionPanel.toggle($event)">
            </button>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>

  <p-overlayPanel #blRowActionPanel appendTo="body">
    <ng-template pTemplate>
      <div class="mob-action-list">
        <button pButton type="button" class="p-button-outlined mob-action-item"
                icon="pi pi-pencil" label="Edit Booking"
                (click)="editdatanew(selectedAction?.bookingId); blRowActionPanel.hide()">
        </button>
      </div>
    </ng-template>
  </p-overlayPanel>

</div>

<!-- ── Desktop view (unchanged) ──────────────────────────── -->
<div *ngIf="!useMobileView && ListBookings && AccessAllowed" class="p-3 flex flex-column flex-auto">

    <h3 style="margin-bottom: -40px" i18n>{{BookingsTitle}}
        <button pTooltip="Show critieria" pButton type="button" style="height: 50px;width: 180px;margin-left:10px;" class="p-button-sm p-element p-ripple p-button-warning p-button p-component" (click)="showCriteria()">
            <span class="pi pi-sliders-h" style="margin-right:8px; font-size: 16px;"></span>
            <span style="font-size:17px;">{{showCriteriaButtonText}}</span>
        </button>
    </h3>

    <div style="text-align: right;margin-top: -10px;">
        
        <p-toggleButton pTooltip="Show disabled bookings" class="p-button-sm p-button-danger p-component" [(ngModel)]="isDisabled" offIcon="pi pi-eye-slash" onIcon="pi pi-eye" [style]="{'margin-right': '10px', 'color' : 'white', 'background-color': '#EF4444', 'font-weight': 'normal', 'height': '50px'}" (click)="toggleDisabled()">
        </p-toggleButton>
    </div>

    <div class="surface-card p-4 shadow-2 border-round" style="margin-top:13px;" *ngIf="criteria">
    <div style="margin-bottom:15px;">
        <span style="float: left; margin-top: 10px; margin-right: 10px;">From:</span>
        <div style="float:left; width: 200px;">
            <p-calendar  [selectOtherMonths]="true" [(ngModel)]="BookingDate" firstDayOfWeek="1" dateFormat="dd/mm/yy" [utc]="false" [showIcon]="true"></p-calendar>  
        </div> 
        <span style="float: left; margin-top: 10px; margin-right: 10px;margin-left:10px">To:</span>
        <div style="float:left; width: 200px;">
            <p-calendar  [selectOtherMonths]="true" [(ngModel)]="BookingDateEnd" firstDayOfWeek="1" dateFormat="dd/mm/yy" [utc]="false" [showIcon]="true"></p-calendar>  
        </div> 

    </div>
    <br>

    <div class="surface-card p-4 shadow-2 border-round" style="width:100%;float:left;margin-bottom: 20px;margin-top:20px">
        <div class="field mb-4 col-12">
          <label for="" class="font-medium">Select Tags (Selecting no tags will return all data regardless of tag)</label>
          <br />
          <p-multiSelect [options]="tags" optionLabel="name" [(ngModel)]="chosentags" display="chip">
            <ng-template let-value pTemplate="selectedItems">
              <span *ngFor="let tag of chosentags">
                <p-chip label="{{tag.name}}" styleClass="mr-2"  [style]="{'background': tag.colour, 'color': 'white', 'border-radius': '5px' }">
                </p-chip>
              </span>
              <div *ngIf="!chosentags || chosentags.length === 0" class="country-placeholder"> Select Tag(s) </div>
            </ng-template>
          </p-multiSelect>
        </div>
      </div>

    <button pTooltip="Get Bookings" pButton type="button" style="float: right; height: 50px; margin-right: 10px;" class="p-button-sm p-element p-ripple p-button-warning p-button p-component" (click)="showBookings()">
        <span class="pi pi-search" style="margin-right:8px; font-size: 16px;"></span>
        <span style="font-size:17px;">Search</span>
    </button>

    </div>
    <div class="surface-card p-4 shadow-2 border-round" style="margin-top:20px;">
    <!-- <p-table  #resourceTable (onPage)="paginate($event)"
    [columns]="cols"
    [value]="ListBookings" sortField="startTime" [paginator]="true" [rows]="10" 
    [showCurrentPageReport]="true" responsiveLayout="scroll"
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords}" 
    [rowsPerPageOptions]="[10,25,50]" 
    [globalFilterFields]="['name', 'bookingId', 'bookingIdHR', 'packageName']"
    [(selection)]="selectedItems"
    responsiveLayout="scroll"
    [selectionPageOnly]="true">

        <ng-template pTemplate="header">
            <tr>
                <th width="1%">
                    &nbsp;
                </th>
                <th width="1%">
                    &nbsp;
                </th>
                <th pSortableColumn="bookingId" width="8%">Sales ID
                    <p-sortIcon [field]="bookingIdHR"></p-sortIcon>
                </th>
                <th pSortableColumn="startTime" width="10%">Start Date
                    <p-sortIcon [field]="startTime"></p-sortIcon>
                </th>
                <th pSortableColumn="startTime" width="8%">Start
                    <p-sortIcon [field]="startTime"></p-sortIcon>
                </th>
                <th pSortableColumn="name" width="8%">Name
                    <p-sortIcon [field]="name"></p-sortIcon>
                </th>
                <th pSortableColumn="packageName" width="15%">Package
                    <p-sortIcon [field]="packageName"></p-sortIcon>
                </th>
                <th pSortableColumn="guests" width="6%">Guests
                    <p-sortIcon [field]="guests"></p-sortIcon>
                </th>
                <th pSortableColumn="total" width="5%">Total
                    <p-sortIcon [field]="total"></p-sortIcon>
                </th>
                <th pSortableColumn="outstanding" width="5%">O/S
                    <p-sortIcon [field]="outstanding"></p-sortIcon>
                </th>
                <th width="20%">
                    Extras
                </th>
                <th width="5%">
                    Allergy
                </th>
                <th width="5%"></th>
                <th width="5%"></th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-data>
            <tr [ngStyle]="{'background-color': (data.disabled==true) ? '#fee' : '#ffffff'}"  *ngIf="!data.inProgress && !inProgress" onmouseover="this.originalstyle=this.style.backgroundColor;this.style.backgroundColor='#dddddd'" onmouseout="this.style.backgroundColor=this.originalstyle;" [ngStyle]="{'background-color': (data.disabled==true) ? '#fee' : '#ffffff'}">
                <td (click)="editdatanew(data.bookingId)" >
                    <span *ngIf="data.publicBooking" class="pi pi-user"></span> 
                </td>
                <td (click)="editdatanew(data.bookingId)">
                    <span style="color:red" *ngIf="data.notes != '' && data.notes != null" class="pi pi-exclamation-circle" pTooltip="{{data.notes}}"></span> 
                </td>
                <td (click)="editdatanew(data.bookingId)">{{data.bookingIdHR}}</td>
                <td (click)="editdatanew(data.bookingId)">{{data.startTime | date:'dd/MM/yy'}}</td>
                <td (click)="editdatanew(data.bookingId)">{{data.startTime | date:'HH:mm' : 'UTC'}}</td>
                <td (click)="editdatanew(data.bookingId)">{{data.name}}</td>
                <td (click)="editdatanew(data.bookingId)">{{data.packageName}}</td>
                <td (click)="editdatanew(data.bookingId)">{{data.guests}}</td>
                <td (click)="editdatanew(data.bookingId)">{{data.total | currency: (data.currency || CurrencySymbol)}}</td>
                <td (click)="editdatanew(data.bookingId)" *ngIf="data.outstanding <=0">{{data.outstanding | currency: (data.currency || CurrencySymbol)}}</td>
                <td (click)="editdatanew(data.bookingId)" *ngIf="data.outstanding >0"><span style="color: Red; font-weight: bold;">{{data.outstanding | currency: (data.currency || CurrencySymbol)}}</span></td>
                <td (click)="editdatanew(data.bookingId)">{{data.extrastext}}</td>
                <td (click)="editdatanew(data.bookingId)">{{data.allergy}}</td>

                <td *ngIf="!data.disabled"><button  pTooltip="Send Booking Confirmation" pButton type="button" class="p-button-sm p-element p-ripple p-button-warning p-button p-component" (click)="emailConf(data.bookingId)" i18>
                    <span class="pi pi-envelope"></span>
                </button></td>

                <td *ngIf="!data.disabled"><button pButton type="button" class="p-button-sm p-element p-ripple p-button-danger p-button p-component" (click)="disableData(data.bookingId)" i18>
                    <span class="pi pi-trash"></span>
                </button></td>

                <td *ngIf="data.disabled"><button pButton type="button" class="p-button-sm p-element p-ripple p-button-success p-button p-component" (click)="undisableData(data.bookingId)" i18>
                    <span class="pi pi-check-circle"></span>
                </button></td>

                <td *ngIf="data.disabled">&nbsp;</td>
            </tr>
        </ng-template>
    </p-table> -->
    
    <p-table  #resourceTable
    [columns]="cols"
    [value]="ListBookings" sortField="startTime" [paginator]="true" [rows]="10"
    [showCurrentPageReport]="true" responsiveLayout="scroll"
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
    [rowsPerPageOptions]="[10,25,50]"
    [globalFilterFields]="['name', 'bookingId', 'bookingIdHR', 'packageName']"
    [(selection)]="selectedItems"
    responsiveLayout="scroll"
    [selectionPageOnly]="true"
    sortField="name" [sortOrder]="1"
    [customSort]="true"
    (sortFunction)="customSort($event)"
    >
    <ng-template pTemplate="caption">
        <div class="flex">
        <button
            type="button"
            pButton
            pRipple
            icon="pi pi-file-excel"
            (click)="resourceTable.exportCSV()"
            class="mr-2"
            pTooltip="Export to CSV"
            tooltipPosition="bottom">
        </button>
        </div>
    </ng-template>
        <ng-template pTemplate="header">
            <tr>
                <th width="1%">
                    &nbsp;
                </th>
                <th width="1%">
                    &nbsp;
                </th>
                <th width="1%">
                    &nbsp;
                </th>
                <th pSortableColumn="bookingId" width="8%">Sales ID
                    <p-sortIcon [field]="bookingIdHR"></p-sortIcon>
                </th>
                <th pSortableColumn="startTime" width="10%">Start Date
                    <p-sortIcon [field]="startTime"></p-sortIcon>
                </th>
                <th pSortableColumn="startTime" width="3%">Start
                    <p-sortIcon [field]="startTime"></p-sortIcon>
                </th>
                <th pSortableColumn="name" width="10%">Name
                    <p-sortIcon [field]="name"></p-sortIcon>
                </th>

                <th pSortableColumn="name" width="18%">Admissions
                    <p-sortIcon [field]="admissions"></p-sortIcon>
                </th>
                <th pSortableColumn="packageName" width="13%">Package
                    <p-sortIcon [field]="packageName"></p-sortIcon>
                </th>
                <th pSortableColumn="resourcestring" width="10%">Resource
                    <p-sortIcon field="resourcestring"></p-sortIcon>
                </th>
                <th pSortableColumn="guests" width="6%">Guests
                    <p-sortIcon [field]="guests"></p-sortIcon>
                </th>
                <th pSortableColumn="total" width="5%">Total
                    <p-sortIcon [field]="total"></p-sortIcon>
                </th>
                <th pSortableColumn="outstanding" width="5%">O/S
                    <p-sortIcon [field]="outstanding"></p-sortIcon>
                </th>

                <th width="15%">
                    Extras
                </th>

                <th width="10%">
                    Allergy
                </th>
                <!-- <th></th>
                <th></th> -->
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-data>
            <tr *ngIf="!data.inProgress && !inProgress  && (data.allergy == '' || data.allergy == null)" onmouseover="this.originalstyle=this.style.backgroundColor;this.style.backgroundColor='#dddddd'" onmouseout="this.style.backgroundColor=this.originalstyle;" [ngStyle]="{'background-color': (data.disabled==true) ? '#fee' : '#ffffff'}">
                <td (click)="editdatanew(data.bookingId)" >
                    <span *ngIf="data.publicBooking" class="pi pi-user"></span> 
                </td>
                <td (click)="editdatanew(data.bookingId)">
                    <span style="color:red" *ngIf="data.notes != '' && data.notes != null" class="pi pi-exclamation-circle" pTooltip="{{data.notes}}"></span> 
                </td>
                <td>
                    <span style="color:red" *ngIf="data.awaitingpayment" class="pi pi-dollar" pTooltip="A payment link has been sent for this booking."></span>
                </td>
                <td (click)="editdatanew(data.bookingId)">{{data.bookingIdHR}}</td>
                <td (click)="editdatanew(data.bookingId)">{{data.startTime | date:'dd/MM/yy'}}</td>
                <td (click)="editdatanew(data.bookingId)">{{data.startTime | date:'HH:mm' : 'UTC'}}</td>
                <td (click)="editdatanew(data.bookingId)">{{data.name}} ({{maskMobile(data.phone)}})</td>
                <td (click)="editdatanew(data.bookingId)">{{data.admissions}}</td>
                <td (click)="editdatanew(data.bookingId)">{{data.packageName}}</td>
                <td (click)="editdatanew(data.bookingId)">{{data.resourcestring}}</td>
                <td (click)="editdatanew(data.bookingId)">{{data.guests}}</td>
                <td (click)="editdatanew(data.bookingId)">{{data.total | currency: (data.currency || CurrencySymbol)}}</td>
                <td (click)="editdatanew(data.bookingId)" *ngIf="data.outstanding <=0">{{data.outstanding | currency: (data.currency || CurrencySymbol)}}</td>
                <td (click)="editdatanew(data.bookingId)" *ngIf="data.outstanding >0"><span style="color: Red; font-weight: bold;">{{data.outstanding | currency: (data.currency || CurrencySymbol)}}</span></td>
                <td (click)="editdatanew(data.bookingId)">{{data.extrastext}}</td>
                <td (click)="editdatanew(data.bookingId)">{{data.allergy}}</td>

                <!-- <td *ngIf="!data.disabled"><button  pTooltip="Send Booking Confirmation" pButton type="button" class="p-button-sm p-element p-ripple p-button-warning p-button p-component" (click)="emailConf(data.bookingId)" i18>
                    <span class="pi pi-envelope"></span>
                </button></td>

                <td *ngIf="!data.disabled"><button pButton type="button" class="p-button-sm p-element p-ripple p-button-danger p-button p-component" (click)="disableData(data.bookingId)" i18>
                    <span class="pi pi-trash"></span>
                </button></td>

                <td *ngIf="data.disabled"><button pButton type="button" class="p-button-sm p-element p-ripple p-button-success p-button p-component" (click)="undisableData(data.bookingId)" i18>
                    <span class="pi pi-check-circle"></span>
                </button></td> -->
            </tr>

            <tr *ngIf="!data.inProgress && !inProgress && data.allergy != '' && data.allergy != null" onmouseover="this.originalstyle=this.style.backgroundColor;this.style.backgroundColor='#dddddd'" onmouseout="this.style.backgroundColor=this.originalstyle;" [ngStyle]="{'background-color': (data.disabled==true) ? '#fee' : '#FFFFB2'}">
                <td (click)="editdatanew(data.bookingId)" >
                    <span *ngIf="data.publicBooking" class="pi pi-user"></span>
                </td>
                <td (click)="editdatanew(data.bookingId)">
                    <span style="color:red" *ngIf="data.notes != '' && data.notes != null" class="pi pi-exclamation-circle" pTooltip="{{data.notes}}"></span>
                </td>
                <td>
                    <span style="color:red" *ngIf="data.awaitingpayment" class="pi pi-dollar" pTooltip="A payment link has been sent for this booking."></span>
                </td>
                <td (click)="editdatanew(data.bookingId)">{{data.bookingIdHR}}</td>
                <td (click)="editdatanew(data.bookingId)">{{data.startTime | date:'dd/MM/yy'}}</td>
                <td (click)="editdatanew(data.bookingId)">{{data.startTime | date:'HH:mm' : 'UTC'}}</td>
                <td (click)="editdatanew(data.bookingId)">{{data.name}} ({{maskMobile(data.phone)}})</td>
                <td (click)="editdatanew(data.bookingId)">{{data.admissions}}</td>
                <!-- <td (click)="editdatanew(data.bookingId)">{{data.email}}</td>
                <td (click)="editdatanew(data.bookingId)">{{data.phone}}</td> -->
                <td (click)="editdatanew(data.bookingId)">{{data.packageName}}</td>
                <td (click)="editdatanew(data.bookingId)">{{data.resourcestring}}</td>
                <td (click)="editdatanew(data.bookingId)">{{data.guests}}</td>
                <td (click)="editdatanew(data.bookingId)">{{data.total | currency: (data.currency || CurrencySymbol)}}</td>
                <td (click)="editdatanew(data.bookingId)" *ngIf="data.outstanding <=0">{{data.outstanding | currency: (data.currency || CurrencySymbol)}}</td>
                <td (click)="editdatanew(data.bookingId)" *ngIf="data.outstanding >0"><span style="color: Red; font-weight: bold;">{{data.outstanding | currency: (data.currency || CurrencySymbol)}}</span></td>
                <td (click)="editdatanew(data.bookingId)">{{data.extrastext}}</td>
                <td (click)="editdatanew(data.bookingId)">{{data.allergy}}</td>
                <td *ngIf="useCounters">

                    <button *ngIf="!data.checkedin" pButton type="button" class="p-button-sm p-element p-ripple p-button-success p-button p-component" style="width:133px;" [disabled]="!isBookingDateToday" (click)="admitall(data.bookingId)">
                        <span class="pi pi-sign-in" style="margin-right:8px;"></span>
                        <span>Admit All</span>
                    </button>

                    <button *ngIf="data.checkedin" pButton type="button" class="p-button-sm p-element p-ripple p-button-danger p-button p-component" style="width:133px;" [disabled]="!isBookingDateToday" (click)="leaveall(data.bookingId)">
                        <span class="pi pi-sign-out" style="margin-right:8px;"></span>
                        <span>Leave All</span>
                    </button>
            
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>
</div>
